// Tab icon and title while the event is in progress (same rule as the beta, sledz-app utils/favicon.js):
// red dot in the icon (public/favicon-live.svg + favicon-live-32.png) and the "● Na żywo · " title prefix.
// Before the start and after the end the plain icon and the original title stay.
// Dates from the API are Polish wall-clock time, also the ones with a "Z" suffix.

const LIVE_TITLE_PREFIX = '● Na żywo · '
const WARSAW_PARTS = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/Warsaw',
  year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit',
  hourCycle: 'h23'
})

// "2026-10-18T10:00:00.000000Z" / "2026-10-18 10:00:00" -> wall-clock ms ("fake UTC"), NaN when unparsable
export function wallClockMs(value) {
  const m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/.exec(String(value || ''))
  if (!m) return NaN
  return Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0))
}

// Current Polish wall-clock time in the same "fake UTC" form
export function warsawNowMs(now = Date.now()) {
  const p = Object.fromEntries(WARSAW_PARTS.formatToParts(new Date(now)).map(x => [x.type, x.value]))
  return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second)
}

export function eventIsLive(event, now = Date.now()) {
  if (!event) return false
  const start = wallClockMs(event.date_start)
  const end = wallClockMs(event.date_end)
  if (Number.isNaN(start) || Number.isNaN(end)) return false
  const current = warsawNowMs(now)
  return current >= start && current <= end
}

export function faviconHrefs(live) {
  return live
    ? { svg: '/favicon-live.svg', raster: '/favicon-live-32.png' }
    : { svg: '/favicon.svg', raster: '/favicon.ico' }
}

let baseTitle = null
let currentLive = null

export function setLiveFavicon(live) {
  if (typeof document === 'undefined') return
  if (baseTitle === null) baseTitle = document.title.replace(LIVE_TITLE_PREFIX, '')
  if (live === currentLive) return
  currentLive = live
  const { svg, raster } = faviconHrefs(live)
  document.querySelectorAll('link[rel~="icon"]').forEach((link) => {
    const isSvg = link.getAttribute('type') === 'image/svg+xml'
    link.setAttribute('href', isSvg ? svg : raster)
    if (!isSvg) link.removeAttribute('type')
  })
  document.title = live ? LIVE_TITLE_PREFIX + baseTitle : baseTitle
}
